import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import { Pen, ThreeDotsVertical, Trash } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../../../FormComponents/Toasts'
import EditActionModal from './EditActionModal'
import OutsideClickClose from '../../../../../../../OutsideClickClose'
import { useReadOnly } from '../../../../../../../../contexts/ReadOnlyContext'

export default observer(function ActionButtonDropdown({ action, campaignScenario }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const openEditActionModal = () => setModalOpen(true)

  const deleteAction = () => {
    axiosService.delete(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`)
    .then((deletedAction) => {
      campaignScenario.actions = campaignScenario.actions.filter(action => action.id !== deletedAction.id)
      toastSuccess('Action deleted')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  if (readOnly) return null

  return (
    <div className="relative">
      <button className="mx-4 p-2 rounded-md" onClick={toggleDropdown}><ThreeDotsVertical /></button>
      <OutsideClickClose
        isOpen={dropdownOpen}
        onClose={() => setDropdownOpen(false)}
      >
        {dropdownOpen &&
          <div className="absolute bg-green h-full rounded-md flex" style={{ left: -10, bottom: -35 }}>
            <button className="bg-gray-400 text-white py-2 px-3 rounded-l-md z-10 hover:bg-rb-green" onClick={openEditActionModal}><Pen /></button>
            <button className="bg-gray-400 text-white z-10 py-2 px-3 hover:bg-rb-green rounded-r-md" onClick={deleteAction}><Trash /></button>
          </div>
        }
      </OutsideClickClose>
      <EditActionModal open={modalOpen} setOpen={setModalOpen} action={action} toggleDropdown={toggleDropdown} />
    </div>
  )
})